import React from 'react';
import { createRoot } from 'react-dom/client';
import '@/assets/styles/common.scss';
import 'reset-css'
import App from './App';
import {HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    // <React.StrictMode>
        <HashRouter>
                <Provider store={store}>
                    <App />
                </Provider>
        </HashRouter>
    // </React.StrictMode>,
);
